import { QueryFunctionContext, UseInfiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query";
import { cartClient } from "@core/clients";
import { SharedCart } from "@core/types";

const DEFAULT_PER_PAGE = 10;

type QueryParams = {
  perPage?: number;
};

type QueryKey = ["shared-cart", "all", QueryParams | undefined];
type Options = UseInfiniteQueryOptions<SharedCart[] | null, any, SharedCart[] | null, SharedCart[] | null, QueryKey>;

const useGetAllSharedCartsInfiniteQuery = (config: { options?: Options; params?: QueryParams } = {}) => {
  const perPage = config.params?.perPage ?? DEFAULT_PER_PAGE;

  return useInfiniteQuery<SharedCart[] | null, any, SharedCart[] | null, QueryKey>({
    queryKey: ["shared-cart", "all", config.params],
    queryFn: async (queryContext: QueryFunctionContext<QueryKey, { page: number }>) => {
      const { pageParam = { page: 1 } } = queryContext;

      return await cartClient.getAllSharedCarts({
        page: pageParam.page,
        perPage,
      });
    },
    getNextPageParam: (lastPage, allPages) => {
      const totalLoaded = allPages.reduce((sum, page) => sum + (page?.length ?? 0), 0);

      if (lastPage !== null && lastPage.length >= perPage) {
        return { page: Math.ceil(totalLoaded / perPage) + 1 };
      }

      // Explicit undefined = no more pages
      return undefined;
    },
    ...config.options,
  });
};

export default useGetAllSharedCartsInfiniteQuery;
